export default "__VITE_ASSET__BAzlO1BO__"